function useInputStyles() {
  return {
    // prettier-ignore
    common: {
      wrapper: "w-full flex items-center overflow-hidden text-gray-600 dark:text-gray-400 text-sm",
      input: "w-full appearance-none placeholder:text-gray-400 dark:placeholder:text-gray-500 px-3 focus:outline-none text-gray-600 dark:text-gray-400 disabled:cursor-not-allowed"
    },
    error: {
      wrapper: "ring-red-400 dark:ring-red-500",
      input: "bg-red-50/25"
    },
    rounded: {
      default: "rounded",
      full: "rounded-full",
      none: ""
    },
    sizes: {
      small: {
        wrapper: "h-8",
        input: "h-8"
      },
      large: {
        wrapper: "h-9",
        input: "h-9"
      }
    },
    variants: {
      default: {
        wrapper: "bg-white dark:bg-gray-900 shadow ring-1 ring-gray-950/10 dark:ring-gray-100/10 focus-within:ring-2 focus-within:ring-primary-500 dark:focus-within:ring-gray-500",
        input: "bg-white dark:bg-gray-900"
      },
      ghost: {
        wrapper: "bg-gray-100 dark:bg-gray-900 focus-within:ring-2 focus-within:ring-primary-500 dark:focus-within:ring-gray-500",
        input: "bg-gray-100 dark:bg-gray-900"
      },
      none: {
        wrapper: "",
        input: "dark:bg-gray-900"
      }
    }
  };
}

export { useInputStyles };
